export default '/build/9ad90687.svg'